import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js/instance/starts-with";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _Set from "@babel/runtime-corejs3/core-js/set";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import DOMPurify from "dompurify";
import Vue from "vue";
import Loader from "./preload";
import { S3_SIGNATURE_BUCKET_URL, showToast, S3_PUBLIC_DOCUMENT_ENDPOINT } from "./constants";
import Amplitude from "./amplitude";
import { putAccountsApi, getSecureAccountsApi, putS3Data } from "./ajax";
import EmailAttachmentTemplate from "@Shared/@HandlebarsTemplates/general/_email-attachments.hbs";
import i18n from "@Shared/i18n";
import { cloneDeep, defer, find, forEach, isArray, isEmpty, isPlainObject, startCase, toUpper } from "lodash";
import { customFieldsTypeDefinitions } from "@Shared/@Utils/utils";
import { DEFAULTSUBSTITUTIONSTAGS } from "@Broker/js/utils/store-helpers/client-profile";
export default class RichTextEditor {
  /**
   * Editor options
   *
   * @typedef {Object} options
   * @property {String}           options.class extra class to add to container
   * @property {String}           options.height editor initial height
   * @property {Boolean}          options.visible show after init?
   * @property {Boolean}          options.resizebar show resize bar?
   * @property {Boolean}          options.substitutionHints activate substitution hints?
   * @property {Array|Function}   options.hints Array of hints, if Function is passed, passes defaults to that function and expects array in return
   * @property {Number}           options.hintThreshold Minimum number of letters to start showing hints
   * @property {Boolean}          options.showMergeTags show merge tabs button in toolbar?
   * @property {Array|Function}   options.mergeTags Array of merge tags, if Function is passed, passes defaults to that function and expects array in return
   * @property {Boolean}          options.attachments show attachment button in toolbar?
   * @property {Boolean}          options.generateEmail show auto-generate email button?
   * @property {Boolean}          options.dialogsInBody place dialogs within body
   * @property {Object}           options.buttons set of buttons selectors
   * @property {String}           options.buttons.show show button selector
   * @property {String}           options.buttons.preview preview button selector
   * @property {String}           options.buttons.toggle toggle button selector
   * @property {Object}           options.callbacks set of callbacks
   * @property {Function}         options.callbacks.onShow callback triggered after editor is shown
   * @property {Function}         options.callbacks.onHide callback triggered after editor is hidden
   * @property {Function}         options.callbacks.onChange callback triggered after editor content changed
   *
   *
   */

  /**
   *
   * @param target editor target element
   * @param {{height: string}} options list of options and callbacks
   */
  constructor(target, options) {
    /**
     * Shows the editor and returns a function for eventHandler to fill parameters.
     * For internal usage.
     *
     */
    _defineProperty(this, "_show", () => {
      const editorElement = $(this._targetElement);
      this._init();
      editorElement.data("shown", true);
      editorElement.removeClass("editor-preview-mode");
      return this._options.callbacks.onShow;
    });
    /**
     * Hides the editor and returns a function for eventHandler to fill parameters.
     * For internal usage.
     *
     */
    _defineProperty(this, "_hide", () => {
      const editorElement = $(this._targetElement);
      this._destroy();
      editorElement.data("shown", false);
      editorElement.addClass("editor-preview-mode");
      return this._options.callbacks.onHide;
    });
    /**
     * Show/hide the editor and returns a function for eventHandler to fill parameters.
     * For internal usage.
     *
     */
    _defineProperty(this, "_toggle", () => {
      const editorElement = $(this._targetElement);
      const {
        shown
      } = editorElement.data();
      return shown ? this._hide() : this._show();
    });
    _defineProperty(this, "_onImageUpload", async file => {
      const editorElement = $(this._targetElement);
      const container = editorElement.parent();
      try {
        Loader.start(container);
        const {
          url
        } = await this._uploadImageToS3(file);
        editorElement.summernote("focus");
        editorElement.summernote("insertImage", url);
        editorElement.trigger("summernote.change");
        editorElement.trigger("input");
      } catch (e) {
        showToast("error", "cantUploadFile");
        Amplitude.logHandledError(e, {});
      } finally {
        Loader.stop(container);
      }
    });
    this._attachedFiles = [];
    this._editorInstance = null;
    this._targetElement = target;
    this._ignoreNextChanges = false;
    this._functionOptions = ["hints", "mergeTags"];
    this._defaults = {
      loadPreferences: true,
      placeholder: "",
      airMode: false,
      class: "",
      visible: true,
      resizebar: false,
      height: 300,
      substitutionHints: false,
      attachments: false,
      generateEmail: false,
      hints: [DEFAULTSUBSTITUTIONSTAGS.FIRST_NAME, DEFAULTSUBSTITUTIONSTAGS.LAST_NAME, "FIRST_NAME LAST_NAME", "Hello FIRST_NAME LAST_NAME", "Hi FIRST_NAME"],
      mergeTags: [DEFAULTSUBSTITUTIONSTAGS.FIRST_NAME, DEFAULTSUBSTITUTIONSTAGS.LAST_NAME, DEFAULTSUBSTITUTIONSTAGS.REF_FIRST_NAME, DEFAULTSUBSTITUTIONSTAGS.REF_LAST_NAME],
      participants: [],
      showMergeTags: false,
      showApplicationMergeTags: false,
      hintThreshold: 3,
      buttons: {
        show: "",
        preview: "",
        toggle: ""
      },
      callbacks: {
        onShow: () => {},
        onHide: () => {},
        onImageUpload: ([file]) => {
          this._onImageUpload(file);
        },
        onChange: () => {},
        onPaste: () => {},
        onBlur: () => {},
        onAttachmentChange: () => {},
        onOpenGenerateEmailModal: () => {}
      },
      tableClassName: "",
      dialogsInBody: false,
      blockPastedImages: false,
      sanitizeContent: html => RichTextEditor.sanitizeHtml(html)
    };
    this._options = $.extend(true, {}, this._defaults, this.callBackOptions(options));
    if (this._options.attachments) {
      this._initAttachmentRemoveListener();
    }
    this.load(this._targetElement, this._options.visible);
  }
  static sanitizeHtml(html, options = {}) {
    const defaultOptions = {
      RETURN_DOM: false,
      USE_PROFILES: {
        html: true
      }
    };
    return DOMPurify.sanitize(html, _objectSpread(_objectSpread({}, defaultOptions), options));
  }
  callBackOptions(options) {
    let optionsWithFunctionValues = cloneDeep(options);
    forEach(this._functionOptions, key => {
      if (typeof options[key] !== "function") return;
      optionsWithFunctionValues[key] = options[key](this._defaults[key]);
      if (!isArray(optionsWithFunctionValues[key]) && isArray(this._defaults[key])) throw `'${key}' as callback needs to return an array`;
    });
    return optionsWithFunctionValues;
  }
  updateOptions(options) {
    const mergedOptions = _objectSpread(_objectSpread({}, this._options), options);
    this._options = this.callBackOptions(mergedOptions);
    this.load(this._targetElement, this._options.visible, true);
  }

  /**
   * Gets private editor instance
   */
  get instance() {
    return $(this._targetElement).summernote;
  }

  /**
   * Gets private current options for the editor
   */
  get options() {
    return this._options;
  }

  /**
   * Do Markup init tasks before loading the editor
   */
  _prepareHTML() {
    $(this._targetElement).addClass(this._options.class).addClass("rich-text-editor");
  }
  _substitutionHintOptions() {
    const {
      hints = [],
      hintThreshold
    } = this._options;
    if (hints.length === []) return {};
    return {
      match: /^(\{{0,2}(\b(\w{1,}))?)$/,
      search: (keyword, callback) => {
        callback($.grep(hints, item => {
          if (_startsWithInstanceProperty(keyword).call(keyword, "{")) return true;
          if (keyword.length >= hintThreshold) {
            var _context;
            const itemIsObjectTag = isPlainObject(item);
            const tagContent = itemIsObjectTag ? item.name : item;
            return _includesInstanceProperty(_context = tagContent.toLowerCase()).call(_context, keyword.toLowerCase());
          }
          return false;
        }));
      },
      content: item => {
        var _context2;
        return _mapInstanceProperty(_context2 = item.split(" ")).call(_context2, part => {
          const uppercase = toUpper(part);
          if (part === uppercase) {
            return `{{${part}}} `;
          }
          return part;
        }).join(" ");
      }
    };
  }
  /**
   * Init the editor calling the editor lib init method
   * @param {Boolean} showAfter if should show the editor after init
   */
  _init(showAfter = true, reload = false) {
    const target = $(this._targetElement);
    if (showAfter) {
      if (target.data("editor-init")) {
        target.summernote("destroy");
      }
      const customButtons = {};
      const toolbar = [["style", ["style"]], ["font", ["bold", "italic", "underline", "strikethrough", "clear"]], ["fontname", ["fontname"]], ["fontsize", ["fontsize"]], ["color", ["forecolor", "backcolor"]], ["para", ["ul", "ol", "paragraph"]]];
      if (this._options.airMode) {
        toolbar.push(["insert", ["link"]]);
      } else {
        toolbar.push(["insert", ["link", "picture"]], ["control", ["undo", "redo"]], ["view", ["fullscreen", "codeview", "help"]]);
      }
      if (this._options.showMergeTags) {
        toolbar.push(["mergeTagDropdown", ["mergeTagGroup"]]);
        customButtons.mergeTagGroup = this.getMergeTabButtonGroup(target);
      }
      if (this._options.showApplicationMergeTags) {
        toolbar.push(["applicationMergeTagDropdown", ["applicationMergeTagGroup"]]);
        customButtons.applicationMergeTagGroup = this.getApplicationMergeTabButtonGroup(target);
      }
      if (this._options.attachments) {
        toolbar.push(["attachmentsButton", ["attachmentsGroup"]]);
        customButtons.attachmentsGroup = this.getAttachmentButton();
      }
      if (this._options.generateEmail) {
        toolbar.push(["generateEmailButton", ["generateEmailModal"]]);
        customButtons.generateEmailModal = this.generateEmailButton();
      }
      const hint = this._options.substitutionHints ? this._substitutionHintOptions() : undefined;
      target.summernote({
        placeholder: this._options.placeholder,
        disableDragAndDrop: true,
        focus: !reload,
        height: this._options.height,
        tableClassName: this._options.tableClassName,
        hint,
        callbacks: {
          onInit: () => {
            target.data("editor-init", true);
            if (!reload) target.summernote("focus");
            if (this._options.airMode) {
              target.next(".note-editor").addClass("air-mode");
            }
            this._initDropListener();
            if (!this._options.loadPreferences) return;
            this._ignoreNextChanges = true;
            try {
              this._bindFontFamilyChange();
              this._bindFontSizeChange();
              if (!reload) this._loadStorage();
            } catch (e) {
              Amplitude.logHandledError(e, {}, "Error while loading text editor preferences");
            } finally {
              this._ignoreNextChanges = false;
              document.getElementsByClassName("note-codable")[0].setAttribute("id", "email-editor-id");
            }
          },
          onImageUpload: this._options.callbacks.onImageUpload,
          onChange: async contents => {
            if (this._ignoreNextChanges) return;
            const editorElement = $(this._targetElement);
            if (!reload) editorElement.trigger("input").trigger("change");
            this._options.callbacks.onChange(editorElement, this._options.sanitizeContent(contents));
          },
          onPaste: async event => {
            var _event$originalEvent;
            const editorElement = $(this._targetElement);
            const clipboardData = (_event$originalEvent = event.originalEvent) == null ? void 0 : _event$originalEvent.clipboardData;
            const html = (clipboardData == null ? void 0 : clipboardData.getData("text/html")) || "";
            const text = (clipboardData == null ? void 0 : clipboardData.getData("text/plain")) || "";
            const sanitizedHtml = this._options.sanitizeContent(html);
            if (this._options.blockPastedImages && (RichTextEditor.clipboardHasImage(clipboardData) || html !== sanitizedHtml)) {
              event.preventDefault();
              if (sanitizedHtml) {
                editorElement.summernote("pasteHTML", sanitizedHtml);
              } else if (text) {
                editorElement.summernote("pasteHTML", `<p>${DOMPurify.sanitize(text).replace(/\n/g, "<br>")}</p>`);
              }
              return;
            }
            // Method for when users drag-selects and pastes images directly from a webpage or another source
            const handledImagePaste = await this._handlePastedImages(event);
            if (handledImagePaste) return;
            this._options.callbacks.onPaste(editorElement, event);
            defer(() => {
              editorElement.trigger("summernote.change");
              editorElement.trigger("input");
            });
          },
          onBlur: () => {
            const isTooltipBarVisible = $(".note-popover.popover").is(":visible");
            const {
              airMode
            } = this._options;
            if (airMode && isTooltipBarVisible) return;
            this._options.callbacks.onBlur();
          }
        },
        toolbar,
        buttons: customButtons,
        dialogsInBody: this._options.dialogsInBody
      });
    } else {
      target.addClass("editor-preview-mode");
    }
    target.addClass("no-resizebar");
    target.data("shown", showAfter);
    $("button.note-color-select").text("Customize colors");
  }

  /**
   * Destroys the current loaded editor
   */
  _destroy() {
    const target = $(this._targetElement);
    target.summernote("destroy");
  }

  /**
   * Bind listeners for editor instance events
   */
  _initListeners() {
    const {
      show,
      preview,
      toggle
    } = this._options.buttons;
    const showButton = $(show);
    const previewButton = $(preview);
    const toggleButton = $(toggle);
    if (showButton.exists()) this._bindEvent(showButton, "click", this._show);
    if (previewButton.exists()) this._bindEvent(previewButton, "click", this._hide);
    if (toggleButton.exists()) this._bindEvent(toggleButton, "click", this._toggle);
  }

  /**
   * Binds an event using _eventHandler
   * @param {String | jqNode} target where to bind the event
   * @param {String} event name of the event
   * @param {Function} handler event handler
   */
  _bindEvent(target, event, handler) {
    $(target).on(event, event => this._eventHandler(event, handler));
  }

  /**
   * Event handler take the original event, and a callback, his job
   * is to run the callback and pass the desired (and helpfull) data to
   * Class event handlers (onShow, onHide, etc)
   * - First run the handlers
   * - And then passes the parameters for the Class event handlers
   *
   * @param {Event} originalEvent original event triggered
   * @param {Function} cb callback for the event
   */
  _eventHandler(originalEvent, cb) {
    const editorElement = $(this._targetElement);
    const callbackParams = {
      currentTarget: originalEvent.currentTarget,
      editor: editorElement
    };
    return cb()(callbackParams);
  }
  /**
   * Shows the editor
   */
  show() {
    const editorElement = $(this._targetElement);
    this._show()({
      currentTarget: editorElement,
      editor: editorElement
    });
  }
  /**
   * Hides the editor
   */
  hide() {
    const editorElement = $(this._targetElement);
    this._hide()({
      currentTarget: editorElement,
      editor: editorElement
    });
  }
  /**
   * Shows/Hides the editor
   */
  toggle() {
    const editorElement = $(this._targetElement);
    this._toggle()({
      currentTarget: editorElement,
      editor: editorElement
    });
  }

  /**
   *
   * @param {String | jqNode} target where to load editor
   * @param {boolean} showAfter if show the editor after init or not
   */
  load(target, showAfter = true, reload = false) {
    if (target) this._targetElement = target;
    this._prepareHTML();
    this._init(showAfter, reload);
    this._initListeners();
  }
  async _handlePastedImages(event) {
    var _context3, _context6;
    const originalEvent = (event == null ? void 0 : event.originalEvent) || event;
    const transferData = (originalEvent == null ? void 0 : originalEvent.clipboardData) || (originalEvent == null ? void 0 : originalEvent.dataTransfer);
    if (!transferData) return false;
    const items = _Array$from(transferData.items || []);
    const stringItemPromises = _mapInstanceProperty(_context3 = _filterInstanceProperty(items).call(items, item => item.kind === "string")).call(_context3, item => {
      const type = item.type || "";
      const valuePromise = new _Promise(resolve => {
        try {
          item.getAsString(value => resolve(value || ""));
        } catch (_) {
          resolve("");
        }
      });
      return {
        type,
        valuePromise
      };
    });

    // If user has an image File in their clipboard then we go through the already existing logic
    const hasImageFile = items.some(item => {
      var _context4;
      return item.kind === "file" && _startsWithInstanceProperty(_context4 = item.type).call(_context4, "image/");
    });
    if (hasImageFile) return false;
    const hasHtmlItem = stringItemPromises.some(entry => {
      var _context5;
      return _includesInstanceProperty(_context5 = entry.type).call(_context5, "html");
    });
    const htmlFromGetData = transferData.getData("text/html");
    if (!hasHtmlItem && !htmlFromGetData) return false;
    const editorElement = $(this._targetElement);
    const replaceAllContent = this._isFullEditorSelection();
    event.preventDefault();
    const resolvedStringItems = await _Promise.all(_mapInstanceProperty(stringItemPromises).call(stringItemPromises, async ({
      type,
      valuePromise
    }) => ({
      type,
      value: await valuePromise
    })));
    const html = this._getClipboardHtml(transferData, resolvedStringItems);
    if (!html) return true;
    const parsedHtml = new DOMParser().parseFromString(html, "text/html");
    const dataUrlImageNodes = _filterInstanceProperty(_context6 = _Array$from(parsedHtml.querySelectorAll("img"))).call(_context6, image => {
      var _context7;
      return _startsWithInstanceProperty(_context7 = image.getAttribute("src") || "").call(_context7, "data:image/");
    });
    const insertSanitizedHtml = () => {
      const sanitizedHtml = this._options.sanitizeContent(parsedHtml.body.innerHTML);
      if (replaceAllContent) {
        editorElement.summernote("code", sanitizedHtml);
      } else {
        editorElement.summernote("focus");
        editorElement.summernote("pasteHTML", sanitizedHtml);
      }
      editorElement.trigger("summernote.change");
      editorElement.trigger("input");
    };

    // If no image in pasted html just insert HTML
    if (!dataUrlImageNodes.length) {
      this._cleanupPastedHtml(parsedHtml.body);
      insertSanitizedHtml();
      return true;
    }
    const container = editorElement.parent();
    try {
      Loader.start(container);

      // Upload every pasted img and afterwards swap its src with the S3 URL.
      await _Promise.all(_mapInstanceProperty(dataUrlImageNodes).call(dataUrlImageNodes, async (imageNode, index) => {
        const dataUrl = imageNode.getAttribute("src");
        const file = this._dataUrlToFile(dataUrl, index);
        if (!file) return;
        const {
          url
        } = await this._uploadImageToS3(file);
        imageNode.setAttribute("src", url);
      }));
      this._cleanupPastedHtml(parsedHtml.body);
      insertSanitizedHtml();
    } catch (e) {
      showToast("error", "cantUploadFile");
      Amplitude.logHandledError(e, {});
    } finally {
      Loader.stop(container);
    }
    return true;
  }
  _isFullEditorSelection() {
    var _context8, _context9, _context0;
    const editorElement = $(this._targetElement);
    const editable = _findInstanceProperty(_context8 = editorElement.next(".note-editor")).call(_context8, ".note-editable")[0];
    const selection = window.getSelection();
    if (!editable || !(selection != null && selection.rangeCount)) return false;
    const range = selection.getRangeAt(0);
    const commonAncestor = range.commonAncestorContainer;
    const isInsideEditor = editable === commonAncestor || editable.contains(commonAncestor);
    if (!isInsideEditor) return false;
    const selectedText = _trimInstanceProperty(_context9 = selection.toString().replace(/\s+/g, "")).call(_context9);
    const editorText = _trimInstanceProperty(_context0 = editable.innerText.replace(/\s+/g, "")).call(_context0);
    return !!editorText && selectedText === editorText;
  }

  // When copy pasting raw HTML soime computed lines can be injected thus orphaning certain nodes like images. This method cleans up the pasted HTML
  _cleanupPastedHtml(root) {
    if (!root) return;
    root.querySelectorAll("[style]").forEach(node => {
      node.removeAttribute("style");
    });
    root.querySelectorAll("img").forEach(img => {
      var _context1;
      const next = img.nextSibling;
      if (!next) return;
      const hasInlineSibling = next.nodeType === Node.TEXT_NODE ? _trimInstanceProperty(_context1 = next.textContent || "").call(_context1).length > 0 : next.nodeType === Node.ELEMENT_NODE && !/^(BR|P|DIV|UL|OL|LI|H[1-6]|TABLE|TR|TD|TH|BLOCKQUOTE|HR)$/.test(next.nodeName);
      if (hasInlineSibling) {
        img.parentNode.insertBefore(img.ownerDocument.createElement("br"), next);
      }
    });
  }
  _getClipboardHtml(transferData, resolvedStringItems = []) {
    const htmlFromGetData = transferData.getData("text/html");
    if (htmlFromGetData) return htmlFromGetData;
    const htmlEntry = _findInstanceProperty(resolvedStringItems).call(resolvedStringItems, entry => {
      var _context10;
      return _includesInstanceProperty(_context10 = entry.type).call(_context10, "html");
    });
    if (htmlEntry && htmlEntry.value) return htmlEntry.value;
    let plainText = transferData.getData("text/plain");
    if (!plainText) {
      const plainEntry = _findInstanceProperty(resolvedStringItems).call(resolvedStringItems, entry => {
        var _context11;
        return _includesInstanceProperty(_context11 = entry.type).call(_context11, "plain");
      });
      if (plainEntry) plainText = plainEntry.value;
    }
    if (plainText && _includesInstanceProperty(plainText).call(plainText, "<img")) return plainText;
    return "";
  }
  _dataUrlToFile(dataUrl, index = 0) {
    const now = Date.now();
    const base64Match = dataUrl.match(/^data:(image\/[a-zA-Z0-9.+-]+);base64,(.+)$/);
    if (base64Match) {
      const mimeType = base64Match[1];
      const extension = this._mimeTypeToExtension(mimeType);
      const binaryString = atob(base64Match[2]);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return new File([bytes], `pasted-image-${now}-${index}.${extension}`, {
        type: mimeType
      });
    }
    const textMatch = dataUrl.match(/^data:(image\/[a-zA-Z0-9.+-]+),(.*)$/);
    if (!textMatch) return null;
    const mimeType = textMatch[1];
    const extension = this._mimeTypeToExtension(mimeType);
    const decodedText = decodeURIComponent(textMatch[2]);
    const blob = new Blob([decodedText], {
      type: mimeType
    });
    return new File([blob], `pasted-image-${now}-${index}.${extension}`, {
      type: mimeType
    });
  }
  _mimeTypeToExtension(mimeType = "") {
    const [, subtype = "png"] = mimeType.split("/");
    return subtype.split("+")[0] || "png";
  }
  getHTML() {
    const editorElement = $(this._targetElement);
    editorElement.trigger("summernote.change");
    editorElement.trigger("input");
    return this._options.sanitizeContent(editorElement.val());
  }
  setHTML(htmlString) {
    const editorElement = $(this._targetElement);
    editorElement.summernote("code", this._options.sanitizeContent(htmlString));
  }
  insertLink({
    text,
    url
  }) {
    const sanitizedText = DOMPurify.sanitize(text);
    const editorElement = $(this._targetElement);
    editorElement.summernote("insertNode", $(`<a href="${url}" style="cursor: pointer; text-decoration: underline;">${sanitizedText}</a>`)[0]);
  }
  setAttachedFiles(attachments = []) {
    this._attachedFiles = attachments;
    this._refreshAttachedFiles();
  }
  async _uploadImageToS3(file, attachment) {
    const getSignedURL = async fileName => {
      return getSecureAccountsApi({
        attachment,
        fileName
      }, S3_PUBLIC_DOCUMENT_ENDPOINT);
    };
    const uploadImageToS3 = async file => {
      var _context12;
      const name = _replaceAllInstanceProperty(_context12 = file.name).call(_context12, " ", "-");
      const signed = await getSignedURL(name);
      //TODO: need to do something about this import for broker/client classes
      //eslint-disable-next-line no-undef
      await putS3Data(file, signed.url);
      return {
        url: `${S3_SIGNATURE_BUCKET_URL}/${signed.documentId}`,
        fileName: name,
        documentId: signed.documentId,
        contentType: signed.contentType,
        size: file.size
      };
    };
    return await uploadImageToS3(file);
  }
  _loadStorage() {
    const {
      accountPreferences = {}
    } = Vue.auth.session.get() || {};
    const {
      emailEditorSettings
    } = accountPreferences;
    if (isEmpty(emailEditorSettings)) return;
    const {
      fontSize = null,
      fontStyle = null
    } = emailEditorSettings;
    if (fontSize) this._loadFontSize(fontSize);
    if (fontStyle) this._loadFontStyle(fontStyle);
  }
  _saveEmailPreferences(key, value) {
    const {
      accountPreferences = {}
    } = Vue.auth.session.get() || {};
    const {
      emailEditorSettings: currentEmailEditorSettings
    } = accountPreferences;
    const emailEditorSettings = _objectSpread(_objectSpread({}, currentEmailEditorSettings), {}, {
      [key]: value
    });
    Vue.auth.session.store.commit("AccountStore/SET_ACCOUNT_PREFERENCES", _objectSpread(_objectSpread({}, accountPreferences), {}, {
      emailEditorSettings
    }));
    this._persistEmailPreferences(emailEditorSettings);
  }
  async _persistEmailPreferences(emailEditorSettings) {
    return await putAccountsApi({
      emailEditorSettings
    }, "/preferences");
  }
  _loadFontStyle(fontFamily) {
    const editorElement = $(this._targetElement);
    editorElement.summernote("saveRange");
    editorElement.summernote("fontName", fontFamily);
    editorElement.summernote("restoreRange");
  }
  _loadFontSize(fontSize) {
    const editorElement = $(this._targetElement);
    editorElement.summernote("saveRange");
    editorElement.summernote("fontSize", _parseInt(fontSize));
    editorElement.summernote("restoreRange");
  }
  _bindFontFamilyChange() {
    const editorElement = $(this._targetElement);
    const noteEditor = editorElement.next(".note-editor");
    const fontFamilyDropdown = _findInstanceProperty(noteEditor).call(noteEditor, ".dropdown-fontname");
    const handler = ({
      currentTarget
    }) => {
      var _context13;
      const target = $(currentTarget);
      const fontFamily = _trimInstanceProperty(_context13 = _findInstanceProperty(target).call(target, "span").text()).call(_context13);
      this._saveEmailPreferences("fontStyle", fontFamily);
    };
    fontFamilyDropdown.off("click", ".dropdown-item", handler);
    fontFamilyDropdown.on("click", ".dropdown-item", handler);
  }
  _bindFontSizeChange() {
    const editorElement = $(this._targetElement);
    const noteEditor = editorElement.next(".note-editor");
    const fontSizeDropdown = _findInstanceProperty(noteEditor).call(noteEditor, ".dropdown-fontsize");
    const handler = ({
      currentTarget
    }) => {
      var _context14;
      const target = $(currentTarget);
      const fontSize = _trimInstanceProperty(_context14 = target.text()).call(_context14);
      this._saveEmailPreferences("fontSize", fontSize);
    };
    fontSizeDropdown.off("click", ".dropdown-item", handler);
    fontSizeDropdown.on("click", ".dropdown-item", handler);
  }
  clearAttachedfiles() {
    this._attachedFiles = [];
    this._refreshAttachedFiles();
  }
  getMergeTabButtonGroup(editor) {
    var _context15, _context16, _context17;
    if (!this._options.mergeTags.length) return;
    const participantTypes = _Array$from(new _Set(_mapInstanceProperty(_context15 = _filterInstanceProperty(_context16 = _mapInstanceProperty(_context17 = this._options.participants || []).call(_context17, ({
      type
    }) => type)).call(_context16, Boolean)).call(_context15, type => ({
      type: toUpper(type),
      translatedType: i18n.t("referrers.referrerType." + type)
    }))));
    const participantFields = [{
      value: "FIRST_NAME",
      label: i18n.t("client-profile.participants.customParticipantFirstName")
    }, {
      value: "LAST_NAME",
      label: i18n.t("client-profile.participants.customParticipantLastName")
    }, {
      value: "PHONE",
      label: i18n.t("client-profile.participants.customParticipantPhone")
    }, {
      value: "EMAIL",
      label: i18n.t("client-profile.participants.customParticipantEmail")
    }];
    const buildTagList = (tags, className = "") => `<ul class="dropdown-menu merge-tag-submenu ${className} p-0 m-0">
        ${_mapInstanceProperty(tags).call(tags, tag => {
      const tagName = isPlainObject(tag) ? tag.name : tag;
      const formattedTag = `{{${tagName}}}`;
      if (isPlainObject(tag)) {
        var _find$icon, _find, _tag$type;
        const currentIcon = (_find$icon = (_find = find(customFieldsTypeDefinitions, ({
          key
        }) => tag.type === key)) == null ? void 0 : _find.icon) != null ? _find$icon : "fa fa-text-height";
        const fieldType = startCase((_tag$type = tag.type) != null ? _tag$type : i18n.t("custom-fields.fields.text.label"));
        return `<li class="dropdown-item clickable merge-tag-item" data-merge-tag="${formattedTag}">
                        <span class="tag-text">${formattedTag}</span>
                        <br>
                        <i class="${currentIcon} tiny-font mr-1 mt-2"></i>
                        <span class="bold">${fieldType}</span>
                      </li>`;
      }
      return `<li class="dropdown-item clickable merge-tag-item" data-merge-tag="${formattedTag}">
                      <span class="tag-text">${formattedTag}</span>
                    </li>`;
    }).join("")}
      </ul>`;
    const buildParticipantFieldMenu = type => `<ul class="dropdown-menu merge-tag-submenu participant-fields-submenu p-0 m-0" style="list-style-type: none;">
        ${_mapInstanceProperty(participantFields).call(participantFields, ({
      value: field,
      label
    }) => {
      const mergeTag = `{{PARTICIPANT_${type}_${field}}}`;
      return `<li class="dropdown-item clickable merge-tag-item" data-merge-tag="${mergeTag}">
                      <span class="tag-text">${label}</span>
                    </li>`;
    }).join("")}
      </ul>`;
    const participantsMenu = participantTypes.length > 0 ? `
      <div class="dropdown dropdown-submenu clickable merge-tags-section">
        <div class="dropdown-item d-flex justify-content-between align-items-center">
          <i class="fa fa-chevron-left mr-2 tiny-font"></i>
          <span>${i18n.t("email.substitutionTagsParticipants")}</span>
        </div>
        <ul class="dropdown-menu merge-tag-submenu participant-types-menu p-0 m-0" style="list-style-type: none;">
          ${_mapInstanceProperty(participantTypes).call(participantTypes, ({
      type,
      translatedType
    }) => {
      return `<li class="dropdown-submenu clickable participant-type-item">
                        <div class="dropdown-item d-flex justify-content-between align-items-center w-100">
                          <i class="fa fa-chevron-left mr-2 tiny-font"></i>
                          <span>${translatedType}</span>
                        </div>
                        ${buildParticipantFieldMenu(type)}
                      </li>`;
    }).join("")}
        </ul>
      </div>
    ` : "";
    const generalMenu = `
      <div class="dropdown dropdown-submenu clickable merge-tags-section">
        <div class="dropdown-item d-flex justify-content-between align-items-center">
          <i class="fa fa-chevron-left mr-2 tiny-font"></i>
          <span>${i18n.t("email.substitutionTagsGeneral")}</span>
        </div>
        ${buildTagList(this._options.mergeTags, "general-merge-tags-menu")}
      </div>
    `;
    const dropdownHTML = `
        <div class="merge-tags-dropdown">
          ${generalMenu}
          ${participantsMenu}
        </div>
      `;
    return () => {
      var ui = $.summernote.ui;

      // create button
      var buttonGroup = ui.buttonGroup([ui.button({
        className: "dropdown-toggle",
        contents: `<i class="fa fa-list-alt"/> ${i18n.t("email.substitutionTags")}`,
        tooltip: i18n.t("email.substitutionTags"),
        data: {
          toggle: "dropdown"
        },
        click: () => {
          editor.summernote("saveRange");
        }
      }), ui.dropdown({
        contents: dropdownHTML,
        callback: dropdown => {
          dropdown.css({
            overflow: "visible"
          });
          const dropdownRoot = _findInstanceProperty(dropdown).call(dropdown, ".merge-tags-dropdown");
          dropdownRoot.css({
            position: "relative",
            overflow: "visible"
          });
          _findInstanceProperty(dropdown).call(dropdown, ".merge-tag-submenu").css({
            overflow: "visible"
          });
          _findInstanceProperty(dropdown).call(dropdown, ".participant-types-menu").css({
            maxHeight: "18rem",
            overflowY: "auto",
            overflowX: "hidden"
          });
          _findInstanceProperty(dropdown).call(dropdown, ".general-merge-tags-menu").css({
            maxHeight: "18rem",
            overflowY: "auto",
            overflowX: "hidden"
          });
          _findInstanceProperty(dropdown).call(dropdown, ".participant-type-item").each((index, element) => {
            const participantTypeItem = $(element);
            const submenu = participantTypeItem.children(".participant-fields-submenu");
            if (!submenu.length) return;
            const submenuId = `participant-fields-submenu-${index}`;
            participantTypeItem.attr("data-submenu-id", submenuId);
            submenu.attr("data-submenu-id", submenuId);
            submenu.appendTo(dropdownRoot).hide();
          });
          const getSubmenu = submenuTrigger => {
            const directSubmenu = submenuTrigger.children(".merge-tag-submenu");
            if (directSubmenu.length) {
              return directSubmenu;
            }
            const submenuId = submenuTrigger.attr("data-submenu-id");
            if (!submenuId) return $();
            return dropdownRoot.children(`.merge-tag-submenu[data-submenu-id="${submenuId}"]`);
          };
          _findInstanceProperty(dropdown).call(dropdown, ".merge-tag-item").each((index, element) => {
            $(element).click(event => {
              editor.summernote("restoreRange");
              editor.summernote("focus");
              const mergeTag = $(event.currentTarget).data("merge-tag");
              editor.summernote("insertText", `${mergeTag} `);
              event.preventDefault();
            });
          });
          const hideSubmenus = () => {
            _findInstanceProperty(dropdown).call(dropdown, ".merge-tag-submenu").hide();
          };
          dropdown.on("mouseenter", ".dropdown-submenu", ({
            currentTarget
          }) => {
            const submenuTrigger = $(currentTarget);
            const submenu = getSubmenu(submenuTrigger);
            if (!submenu.length) return;
            submenuTrigger.css("position", "relative");
            if (submenuTrigger.hasClass("participant-type-item")) {
              dropdownRoot.children(".participant-fields-submenu").hide();
              submenu.css({
                display: "block",
                position: "absolute",
                top: 0,
                left: 0,
                right: "auto",
                visibility: "hidden",
                overflow: "visible",
                listStyleType: "none"
              });
              const triggerOffset = submenuTrigger.offset();
              const rootOffset = dropdownRoot.offset();
              const submenuWidth = submenu.outerWidth();
              submenu.css({
                top: triggerOffset.top - rootOffset.top,
                left: triggerOffset.left - rootOffset.left - submenuWidth + 2,
                visibility: "visible"
              });
              return;
            }
            const parentMenu = submenuTrigger.parent(".merge-tag-submenu").length ? submenuTrigger.parent(".merge-tag-submenu") : dropdownRoot;
            _findInstanceProperty(parentMenu).call(parentMenu, ">.dropdown-submenu .merge-tag-submenu").hide();
            const {
              top
            } = submenuTrigger.position();
            const right = submenuTrigger.outerWidth() - 2;
            const submenuStyles = {
              display: "block",
              position: "absolute",
              top,
              right,
              left: "auto",
              listStyleType: "none",
              visibility: "visible"
            };
            if (submenu.hasClass("participant-types-menu") || submenu.hasClass("general-merge-tags-menu")) {
              submenu.css(_objectSpread(_objectSpread({}, submenuStyles), {}, {
                maxHeight: "18rem",
                overflowY: "auto",
                overflowX: "hidden"
              }));
              return;
            }
            submenu.css(_objectSpread(_objectSpread({}, submenuStyles), {}, {
              overflow: "visible"
            }));
          });
          dropdown.on("mouseleave", event => {
            if ($(event.relatedTarget).closest(dropdown).length) return;
            hideSubmenus();
          });
          dropdown.on("click", ".dropdown-submenu > .dropdown-item", event => {
            event.preventDefault();
          });
        }
      })]);
      return buttonGroup.render();
    };
  }
  getApplicationMergeTabButtonGroup(editor) {
    const applicationMergeTags = ["SIMPLE_APPLICATION_LINK", "FULL_APPLICATION_LINK"];
    const dropdownHTML = `
        <ol class="p-0 m-0">
          ${_mapInstanceProperty(applicationMergeTags).call(applicationMergeTags, tag => `<li class="dropdown-item clickable">{{${tag}}}</li>`).join("")}
        </ol>
      `;
    return () => {
      var ui = $.summernote.ui;

      // create button
      var buttonGroup = ui.buttonGroup([ui.button({
        className: "dropdown-toggle",
        contents: '<i class="fa fa-link"/> Insert Application Link',
        tooltip: "Insert Application Link",
        data: {
          toggle: "dropdown"
        },
        click: () => {
          editor.summernote("saveRange");
        }
      }), ui.dropdown({
        contents: dropdownHTML,
        callback: dropdown => {
          _findInstanceProperty(dropdown).call(dropdown, "li").each((index, element) => {
            $(element).click(event => {
              editor.summernote("restoreRange");
              editor.summernote("focus");
              const mergeTag = $(event.currentTarget).text();
              editor.summernote("insertText", `${mergeTag} `);
              event.preventDefault();
            });
          });
        }
      })]);
      return buttonGroup.render();
    };
  }
  getAttachmentButton() {
    if (!this._options.attachments) return;
    return () => {
      var ui = $.summernote.ui;

      // create button
      var button = ui.button({
        contents: `<i class="fa fa-upload" aria-hidden="true"/> ${i18n.t("email.uploadAttachment")}`,
        tooltip: "The sum of all attachments can't be bigger than 25MB",
        click: () => {
          this.insertAttachmentLink();
        }
      });
      return button.render();
    };
  }
  generateEmailButton() {
    if (!this._options.generateEmail) return;
    return () => {
      var ui = $.summernote.ui;
      var button = ui.button({
        contents: `<i class="fa"><svg xmlns="http://www.w3.org/2000/svg" height="12" width="14" viewBox="0 0 576 512"><path d="M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"/></svg> ${i18n.t("email.autoCompose")}</i>`,
        click: () => {
          this._options.callbacks.onOpenGenerateEmailModal();
        }
      });
      return button.render();
    };
  }
  insertAttachmentLink() {
    const loaderContainer = $(this._targetElement).next(".note-editor");
    const fileInput = $(`<input 
        type="file" 
        accept="application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,image/png,image/tiff,image/jpeg,application/x-rar-compressed,application/octet-stream,application/zip,application/x-zip-compressed,multipart/x-zip" 
        style="display: none;"
      />`);
    $("body").append(fileInput);
    const handleFileChange = async event => {
      var _context18;
      Loader.start(loaderContainer);
      const file = event.currentTarget.files[0];
      const totalAttachmentSize = file.size + _reduceInstanceProperty(_context18 = this._attachedFiles).call(_context18, (acc, curr) => {
        acc += curr.size;
        return acc;
      }, 0);

      //Nylas max upload size is 25MB
      if (totalAttachmentSize >= 26000000) {
        showToast("error", "attachmentSize");
      } else {
        const uploadedFile = await this._uploadImageToS3(file, true);
        this._attachedFiles.push(uploadedFile);
        this._refreshAttachedFiles();
      }
      fileInput.remove();
      Loader.stop(loaderContainer);
    };
    fileInput.click();
    fileInput.on("change", handleFileChange);
  }
  _refreshAttachedFiles() {
    $(".note-status-output").css("height", "auto");
    $(".note-status-output").html(EmailAttachmentTemplate({
      attachments: this._attachedFiles
    }));
    this._options.callbacks.onAttachmentChange({
      attachments: this._attachedFiles
    });
  }
  _initAttachmentRemoveListener() {
    $("#email-editor-wrapper").on("click", ".email-attachment-remove", ({
      currentTarget
    }) => {
      var _context19;
      const docId = currentTarget.dataset.documentId;
      this._attachedFiles = _filterInstanceProperty(_context19 = this._attachedFiles).call(_context19, file => file.documentId !== docId);
      this._refreshAttachedFiles();
    });
  }

  /*
   * Because Summernote onDrop is disabled we need to intercept the drop event ourselves.
   * WE do this by binding a raw drop listner on the text area then call the method that triggers the image uploading in s3 9same asa copy pasting)
   */
  _initDropListener() {
    var _context20;
    const editorElement = $(this._targetElement);
    const editable = _findInstanceProperty(_context20 = editorElement.next(".note-editor")).call(_context20, ".note-editable");
    if (!editable.length) return;
    editable.off("drop.rte").on("drop.rte", async event => {
      const originalEvent = event.originalEvent || event;
      if (!(originalEvent != null && originalEvent.dataTransfer)) return;

      // Position the caret at the drop point so the inserted HTML lands where
      // the user dropped it, not at the previous selection.
      this._setCaretFromDropEvent(originalEvent);
      await this._handlePastedImages(event);
    });
  }

  /*
   * We position the caret(cursor) at the drop point (where the user drops the selected section) so the inserted HTML lands where the user dropped it, not at the previous selection.
   */
  _setCaretFromDropEvent(nativeEvent) {
    const {
      clientX,
      clientY
    } = nativeEvent || {};
    if (clientX == null || clientY == null) return;
    let range = null;
    if (document.caretRangeFromPoint) {
      range = document.caretRangeFromPoint(clientX, clientY);
    } else if (document.caretPositionFromPoint) {
      const caretPos = document.caretPositionFromPoint(clientX, clientY);
      if (caretPos) {
        range = document.createRange();
        range.setStart(caretPos.offsetNode, caretPos.offset);
        range.collapse(true);
      }
    }
    if (!range) return;
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  }
  static sanitizeRichTextWithoutEmbeddedMedia(html = "") {
    return DOMPurify.sanitize(html, {
      RETURN_DOM: false,
      USE_PROFILES: {
        html: true
      },
      FORBID_TAGS: ["picture", "source", "audio", "video", "track", "iframe", "embed", "object", "svg", "math", "style"],
      FORBID_ATTR: ["srcset", "xlink:href", "data", "poster"]
    });
  }
  static clipboardHasImage(clipboardData) {
    return _Array$from((clipboardData == null ? void 0 : clipboardData.items) || []).some(item => {
      var _item$type;
      return (_item$type = item.type) == null ? void 0 : _startsWithInstanceProperty(_item$type).call(_item$type, "image/");
    });
  }
}